import { FormControl, FormErrorMessage, FormLabel, Textarea } from '@chakra-ui/react'
import React from 'react'

const FormTextarea = ({ error, isRequired, onChange, id, value, label, placeholder, type, ...rest }) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={Boolean(error)} {...rest}>
      <FormLabel>{label}</FormLabel>
      <Textarea
        id={id}
        value={value}
        type={type}
        placeholder={placeholder}
        onChange={onChange}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  )
}

export default FormTextarea
